import { MerchantService } from './../../_services/merchant.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, Input, inject, Renderer2 } from '@angular/core';
import { ThemeService } from 'src/app/_services/theme.service';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
    selector: 'app-license-container-prod',
    templateUrl: './license-container-prod.component.html',
    styleUrls: ['./license-container-prod.component.scss'],
    standalone: false
})
export class LicenseContainerProdComponent implements OnInit {
  private readonly themeService: ThemeService = inject(ThemeService);
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly overlayContainer: OverlayContainer = inject(OverlayContainer); 
  private readonly snackBar: MatSnackBar = inject(MatSnackBar);
  public merchantService: MerchantService = inject(MerchantService);

  _licenseArray: any;

  @Input() set licenseArray(arr) {
    if (!arr) { return; }
    this._licenseArray = arr;
    if (this.licenseArray) {
      this.activeKey = null;
      this.activeLicenseDiv = true;
      this.setIntegrationType(this.licenseArray);
    }
  }

  get licenseArray() {return this._licenseArray}

  activeLicenseDiv: boolean = false;
  licenseServer: string;
  licenseWizard: string;
  licenseJS: string;
  licenseAndroid: string;
  licenseIos: string;
  theme: string;
  activeKey: string = null;

  licenseCopied = $localize`:@@snackBarMessage-CopiedLicense:Licenza copiata`;
  licenseNotEnable = $localize`:@@snackBarMessage-LicenseNotEnable:Licenza non abilitata`;

  ngOnInit(): void { 
    this.themeService.themeApplied.subscribe(
      theme => {
        if (this.theme) {
          this.renderer.removeClass(document.body, this.theme);
          this.overlayContainer.getContainerElement().classList.remove(this.theme);
        }
        this.renderer.addClass(document.body, theme);
        this.overlayContainer.getContainerElement().classList.add(theme);
        this.theme = theme;
      }
    );
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  copyLicense(license: string){
    const listener = (e) => {
      e.clipboardData.setData('text/plain', (license ? license : ''));
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
    this.openSnackBar(license ? this.licenseCopied : this.licenseNotEnable, '');
  }

  setIntegrationType(integrations) {
    this.licenseServer = null;
    this.licenseWizard = null;
    this.licenseJS = null;
    this.licenseAndroid = null;
    this.licenseIos = null;

    integrations.forEach((element: any) => {
      switch (element.type) {
        case 'SERVER':
          this.licenseServer = element.license_key;
          break;
        case 'WIZARD':
          this.licenseWizard = element.license_key;
          break;
        case 'JS':
          this.licenseJS = element.license_key;
          break;
        case 'ANDROID':
          this.licenseAndroid = element.license_key;
          break;
        case 'IOS':
          this.licenseIos = element.license_key;
          break;
      }
    });
  }

  setActiveKey(key: string) {
    this.activeKey = key;
  }
}
